import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import { Button as AntButton, Modal as AntModal } from 'antd';
import './index.less';
interface IPrintModal {
    visible: boolean;
    printData: any;
    onCancel: () => void;
}

export class PrintModal extends Component<IPrintModal> {
    printArea: any;
    render() {
        const { visible, printData } = this.props;
        // @ts-ignore
        return (
            <AntModal
                visible={visible}
                title="打印"
                onCancel={this.props.onCancel}
                mask
                centered={true}
                footer={null}
                width={850}
            >
                <div className="print">
                    <ReactToPrint
                        trigger={() => <AntButton> 打印 </AntButton>}
                        content={() => this.printArea}
                    />
                </div>
                <div ref={(el) => (this.printArea = el)} className="print-box">
                    {printData.map((item, index) => {
                        return (
                            <div className="print-loop-box" key={index}>
                                {/* <div className='default-img'>我是图片</div> */}
                                <div className="main">
                                    <p className="shopName">{item.shopName}</p>
                                    <p className="base-info flex padding-bottom-3">
                                        <span>
                                            单据日期:{' '}
                                            {item.billDate ? item.billDate.slice(0, 10) : ''}
                                        </span>
                                        <span>销售订单: {item.orderNo}</span>
                                        <span>VIP卡号: {item.vipNo}</span>
                                        <span>VIP名称: {item.vipName}</span>
                                    </p>
                                    {item.sknList && item.sknList.length ? (
                                        <div>
                                            <div className="table">
                                                <div className="table-title flex padding-bottom-3">
                                                    <span className="col-average col-middle">
                                                        商品编码
                                                    </span>
                                                    <span className="col-average col-large">
                                                        商品名称
                                                    </span>
                                                    <span className="col-average">单位</span>
                                                    <span className="col-average">件数</span>
                                                    <span className="col-average">零售单价</span>
                                                    <span className="col-average">金额</span>
                                                    <span className="col-average">实销金额</span>
                                                </div>
                                                <div className="table-content padding-bottom-3">
                                                    {item.sknList.map((innerItem, innerIndex) => {
                                                        return (
                                                            <div
                                                                className="loop-product-info"
                                                                key={innerIndex}
                                                            >
                                                                <div className="product-detail flex">
                                                                    <span className="col-average col-middle">
                                                                        {innerItem.sknCode}
                                                                    </span>
                                                                    <span className="col-average col-large">
                                                                        {innerItem.skuName}
                                                                    </span>
                                                                    <span className="col-average">
                                                                        {innerItem.unit}
                                                                    </span>
                                                                    <span className="col-average">
                                                                        {innerItem.qty}
                                                                    </span>
                                                                    <span className="col-average">
                                                                        {innerItem.price}
                                                                    </span>
                                                                    <span className="col-average">
                                                                        {innerItem.excutePrice}
                                                                    </span>
                                                                    <span className="col-average">
                                                                        {
                                                                            innerItem.afterFoldingPrice
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <div className="product-attrs flex padding-bottom-3">
                                                                    {innerItem.keyValueList
                                                                        .length ? (
                                                                        innerItem.keyValueList.map(
                                                                            (
                                                                                attrItem,
                                                                                attrIndex
                                                                            ) => {
                                                                                return (
                                                                                    <div
                                                                                        className="attr-item"
                                                                                        key={
                                                                                            attrIndex
                                                                                        }
                                                                                    >
                                                                                        <span>
                                                                                            {
                                                                                                attrItem.key
                                                                                            }
                                                                                            :{' '}
                                                                                            {
                                                                                                attrItem.value
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        )
                                                                    ) : (
                                                                        <div className="placeSpan"></div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <p className="flex padding-bottom-3 calculate">
                                                <span>小计件数: {item.currentPageQty}</span>
                                                <span>小计金额: {item.currentPageAmount}</span>
                                                <span></span>
                                            </p>
                                        </div>
                                    ) : (
                                        <span></span>
                                    )}
                                    {item.payList && item.payList.length ? (
                                        <div className="print-footer">
                                            <div
                                                className="settle-table"
                                                style={{
                                                    borderTop:
                                                        item.sknList && item.sknList.length
                                                            ? '1px dashed #959595'
                                                            : 'none',
                                                }}
                                            >
                                                {item.payList.map((settleItem, settleIndex) => {
                                                    return (
                                                        <div
                                                            className="settle-item flex"
                                                            key={settleIndex}
                                                        >
                                                            {settleIndex === 0 ? (
                                                                <span className="settle-item-first">
                                                                    本次支付
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                </span>
                                                            )}
                                                            <span>{settleItem.payTypeName}</span>
                                                            <span>{settleItem.paidAmount}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            {item.totalPage === index + 1 && (
                                                <p className="flex footer-total">
                                                    <span>合计件数: {item.totalQty}</span>
                                                    <span>
                                                        大写实收金额: {item.realTotalPriceStr}
                                                    </span>
                                                    <span>实收金额: {item.realTotalPrice}</span>
                                                </p>
                                            )}
                                        </div>
                                    ) : (
                                        <span></span>
                                    )}
                                    <p className="flex pay-footer padding-bottom-3">
                                        <span>支付时间: {item.payTime}</span>
                                        <span>
                                            {index + 1}/{item.totalPage}
                                        </span>
                                    </p>
                                </div>
                                {/* <div className='default-qr'>我是二维码</div> */}
                            </div>
                        );
                    })}
                </div>
            </AntModal>
        );
    }
}
